import { GrowthBook } from '@growthbook/growthbook';
import { getCookie } from '../../../analytics/helpers/getCookie/getCookie';

import {
  autoAttributesPlugin,
  thirdPartyTrackingPlugin,
} from '@growthbook/growthbook/plugins';

import getEnvFromHost from '../../helpers/getEnvFromHost/getEnvFromHost';

const createGrowthBookClient = () => {
  const hostEnv = getEnvFromHost();
  const isProduction = hostEnv === 'production';

  const growthBookApiHost = isProduction
    ? 'https://www.riverisland.com/cdn/growthbook'
    : 'https://www.ripostprod.com/cdn/growthbook';

  const config = {
    apiHost: growthBookApiHost,
    clientKey: isProduction ? 'sdk-b6lJXkNm1MoDoPFs' : 'sdk-PKKm35QWq6wHFD9',
    enableDevMode: !isProduction,
    plugins: [
      autoAttributesPlugin(),
      thirdPartyTrackingPlugin({
        // Only required for A/B testing
        // Called every time a user is put into an experiment
        additionalCallback: (experiment, result) => {
          console.log('Experiment Viewed', {
            experimentId: experiment.key,
            variationId: result.key,
          });
        },
        trackers: ['gtag', 'gtm'],
      }),
    ],
  };

  const client = new GrowthBook(config);

  const autoAttributes = client.getAttributes();
  const countryCode = document.getElementById('country-code')?.value;
  const currencyCode = document.getElementById('currency-code')?.value;

  const attributes = {
    ...autoAttributes,
    country: countryCode,
    currency: currencyCode,
  };

  const betaGroupId = getCookie('x-bgid-cookie');

  if (betaGroupId && betaGroupId.length > 0) {
    attributes.betaGroupId = betaGroupId;
  }

  client.setAttributes(attributes);

  return client;
};

export { createGrowthBookClient };
